var map = {
	"./1- Mr. P Sobhan Prakash - Honorable Patron Member, Andhra Pradesh.jpg": 82395,
	"./1-ANDHRA PRADESH-K. V. S. S. S. T. V. PRASAD- STATE HEADS.jpg": 61555,
	"./10 - M. Ganesh Babu - State Dy. Secretary  Andhra Pradesh.jpg": 63926,
	"./10-K. Vidya Sagar-State Org. Secretary- Andhra Pradesh.jpg": 66737,
	"./11 - Mr. Kunju Joshua - State Executive Member AP.jpg": 82233,
	"./11-A.Sarat Chandra-State Org. Secretary- Andhra Pradesh.jpg": 18372,
	"./12 - Mr. M V Soma Sekhar - State Member AP.jpg": 72294,
	"./12-Darsi Jeeva Ratnam-State Dy. Secretary- Andhra Pradesh.jpg": 92933,
	"./13 - Mr. Jugal Kishore Dodka - District Secretary Vskp AP.jpg": 98018,
	"./13-B. Kalyan-State Dy. Secretary- Andhra Pradesh.jpg": 66677,
	"./14 - Naval Dodka- Dy. Seceretary - Vskp AP.jpg": 85811,
	"./14-A.Jagan Mohan-State Dy. Secretary- Andhra Pradesh.jpg": 21015,
	"./15 - S. Satish Babu - District Secretary - Vskp AP.jpg": 52840,
	"./15-Dr. B. Nageswara Rao-State Dy. Secretary- Andhra Pradesh.jpg": 56562,
	"./16-Adv. Dr. K. V. K. Chand-State Standing Counsel- Andhra Pradesh.jpg": 85657,
	"./17 - Mr. S. Srinivas Naidu - Dy. Seceretary - Vskp AP.jpeg": 71794,
	"./17-K.Appala Raju-State Standing Counsel- Andhra Pradesh.jpg": 67013,
	"./18 - Ms. Roja Akkaraboyna - Dy. Seceretary - Vskp AP.jpeg": 48079,
	"./18-J. Devi Prasad-State Standing Counsel- Andhra Pradesh.jpg": 12313,
	"./19 - Mr. Ronak Singhi - Dy. Seceretary - Vskp AP.jpg": 88047,
	"./19-K Kishore Kumar-State Executive Member- Andhra Pradesh.jpg": 91698,
	"./2-TAMILNADU-Ezhilarasu. S- STATE HEADS.jpg": 91430,
	"./20 - Mr. M. Srinivasarao - Constituency President - Pendrthy VSKP AP (2).jpg": 35964,
	"./20-Kunju Joshua-State Executive Member- Andhra Pradesh.jpg": 97415,
	"./21 - Mr. M. SUman - District President Srikakulam AP.jpg": 52883,
	"./21-M. Chockalingam- Tamilnadu.jpg": 44727,
	"./22 - Mr. S. Lakshman - District Secretary Srikakulam AP.jpg": 75863,
	"./22-R Saravanan- Tamilnadu.jpg": 14223,
	"./23 - Mr. Ch. Neehar Naidu - - District Secretary Srikakulam AP.jpg": 57182,
	"./23-N. S. Elamugilan- Tamilnadu.jpg": 83109,
	"./24 - Ms. Karanam Harika -  Const. President, SKLM AP.jpg": 3467,
	"./24-K. Nickitha- Tamilnadu.jpg": 48560,
	"./25 - Y. Sumanth - Const. President - Amudhalavalasa, Sklm, AP.jpg": 53038,
	"./25-Adv. S. S. Kishore- Tamilnadu.jpg": 84847,
	"./26-R. G. Ranjthkumar- Tamilnadu.jpg": 15906,
	"./27-K. Richard- Tamilnadu.jpg": 46569,
	"./28-L. Naresh Kumar- Tamilnadu.jpg": 26547,
	"./29-Iqbal Zafar-District Secretary- Visakhapatnam.jpg": 9522,
	"./3-CHHATTISGARH-Dr. MansinghSahu- STATE HEADS.jpg": 91143,
	"./30-Jugal Dodka-District Secretary- Visakhapatnam.jpg": 61485,
	"./31-P.S. Jeevan Nath-District Secretary- Visakhapatnam.jpg": 40157,
	"./32-A.Roja-State Org. Secretary- Visakhapatnam.jpg": 2701,
	"./33-Naval Dodka-District Dy. Secretary- Visakhapatnam.jpg": 53172,
	"./34-S. Satish Babu-District Dy. Secretary- Visakhapatnam.jpg": 561,
	"./35-D.Daivkumari-State Org. Secretary- Visakhapatnam.jpg": 25300,
	"./36-Ronak Singhi-State Org. Secretary- Visakhapatnam.jpg": 75225,
	"./37-S Srinivas Naidu-District Dy. Secretary- Visakhapatnam.jpg": 46248,
	"./38-P Chandra Mohan-District P.R Incharge - Visakhapatnam.jpg": 32840,
	"./39-D Madanmohan Rao-District President- Srikakulam.jpg": 69480,
	"./4 - BNB Sankar - State Secretary.jpeg": 37687,
	"./4-BIHAR-Aditya Mishra- STATE HEADS.jpg": 75634,
	"./40-S Lakshmipati-District Vice  President- Srikakulam.jpg": 36741,
	"./41-D Santosh-District Vice President- Srikakulam.jpg": 19942,
	"./42-M Suman-District Dy. Secretary- Srikakulam.jpg": 20630,
	"./43-Mohammad Rafi-President Srikakulam Constituency- Srikakulam.jpg": 84945,
	"./44-K Krishnamacharya-President Pathapatnam Constituency- Srikakulam.jpg": 17622,
	"./45-J CHADU MANOHAR-President AmadalavalasaConstituency- Srikakulam.jpg": 71193,
	"./46-B Vijaya Krishna-President EtcherlaConstituency- Srikakulam.jpg": 31988,
	"./47-Adv. Kiran Kumar- Vizinagaram.jpg": 85459,
	"./48-P. Dharani Raj-District President- ASR Districit.jpg": 40913,
	"./49-S. Khaja Mohiddin-District Secretary-  ASR Districit.jpg": 2886,
	"./5 - Mr. K. Vidya Sagar - State Secretary.jpeg": 50907,
	"./5-Shridhar Naraharisetti-State Vice President- Andhra Pradesh.jpg": 59620,
	"./50-G. V. V.Nagabhushanam-President Araku Constituency-  ASR Districit.jpg": 41557,
	"./51-V. Veereshappa-District President- Kurnool.jpg": 69226,
	"./52-M. Udaya Bhaskar Raju-District President- Kakinada District.jpg": 78408,
	"./53-S. Viajay Kishore-District President- Ananthapur District.jpg": 69322,
	"./54-Syed MuzeerRozdar-District President- Nellore District.jpg": 17171,
	"./55- P Nagireddy- State In charge- Telangana.jpeg": 26903,
	"./55-V Venkata Kishore- State Secretary- Andhra Pradesh.jpeg": 99360,
	"./6 - A. Sarat Chandra - State Org. Secretary (2).jpeg": 1451,
	"./6-T Chandra Mouli-State Vice President- Andhra Pradesh.jpg": 83640,
	"./7 - DR. NAGESWARA RAO - State Org. Secretary.jpg": 67748,
	"./7-A Kondala Rao-State Vice President- Andhra Pradesh.jpg": 79123,
	"./8 - Y Vijay Bhaskar Organisation Secretary AP STATE.jpeg": 23443,
	"./8-B.N.B. Sankar-State Secretary- Andhra Pradesh.jpg": 46068,
	"./9 - D. Madanmohan Rao - State Org. Secretary AP.jpg": 99364,
	"./9-K. Dinesh Murthy-State Secretary- Andhra Pradesh.jpg": 50622
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 36192;